var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('content-string-edit',{attrs:{"content":_vm.content,"back-route":{ name: 'client-content-strings', params: { clientId: _vm.clientId } }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/strings/edit.vue?vue&type=template&id=4305166c
// module id = qKtf
// module chunks = 0